// extracted by css-extract-rspack-plugin
export default {"generalTabContent":"CheckListOverlayControllerContent_generalTabContent__TogJn"};